import { render, staticRenderFns } from "./breeder-dam-sire-documents-container.vue?vue&type=template&id=07ffc636&scoped=true&lang=pug"
import script from "./breeder-dam-sire-documents-container.js?vue&type=script&lang=js&external"
export * from "./breeder-dam-sire-documents-container.js?vue&type=script&lang=js&external"
import style0 from "./breeder-dam-sire-documents-container.vue?vue&type=style&index=0&id=07ffc636&prod&lang=scss&scoped=true"
import style1 from "./breeder-dam-sire-documents-container.vue?vue&type=style&index=1&id=07ffc636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffc636",
  null
  
)

export default component.exports